import { Component, useEffect } from "react";
import Lenis from "lenis";
import Header from "./components/Header";
import Hero from "./components/Hero";
import RealWork from "./components/RealWork";
import TrustBar from "./components/TrustBar";
import About from "./components/About";
import Services from "./components/Services";
import Differentials from "./components/Differentials";
import VisualBreak from "./components/VisualBreak";
import Portfolio from "./components/Portfolio";
import TransitionBreak from "./components/TransitionBreak";
import Testimonials from "./components/Testimonials";
import Courses from "./components/Courses";
import Process from "./components/Process";
import FAQ from "./components/FAQ";
import Location from "./components/Location";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import MobileCTA from "./components/MobileCTA";
import DevicePanel from "./components/DevicePanel";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-paper p-8 text-center">
                    <p className="font-display text-2xl text-ink">
                        Algo saiu do rumo. Recarregue a página para continuar.
                    </p>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        const onClick = (e) => {
            const anchor = e.target.closest("a[href]");
            if (!anchor) return;
            const href = anchor.getAttribute("href");
            if (href.startsWith("http")) {
                e.preventDefault();
                window.open(href, "_blank", "noopener");
                return;
            }
            if (href.length > 1) {
                e.preventDefault();
                lenis.scrollTo(href, { offset: -72, duration: 1.4 });
            }
        };
        document.addEventListener("click", onClick);

        return () => {
            cancelAnimationFrame(rafId);
            document.removeEventListener("click", onClick);
            lenis.destroy();
        };
    }, []);

    return (
        <ErrorBoundary>
            <Header />
            <main>
                <Hero />
                <RealWork />
                <TrustBar />
                <About />
                <Services />
                <Differentials />
                <VisualBreak />
                <Portfolio />
                <TransitionBreak />
                <Testimonials />
                <Courses />
                <Process />
                <FAQ />
                <Location />
                <FinalCTA />
            </main>
            <Footer />
            <WhatsAppButton />
            <MobileCTA />
            <DevicePanel />
        </ErrorBoundary>
    );
}

export default App;
